import { isLollipop } from '@bubble-ui/particle-design-versions';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    designVersion,
    disabled,
    focused,
    hovered,
    isChecked,
    pressed
  } = _ref;
  var BackgroundAndBorderArgs = {
    interactiveState: disabled ? 'disabled' : pressed ? 'pressed' : hovered ? 'hovered' : 'default',
    isChecked: isChecked ? 'checked' : 'default'
  };
  var backgroundColor = designContext.get('transaction-checkbox/background-color', BackgroundAndBorderArgs);
  var borderColor = designContext.get('transaction-checkbox/border-color', BackgroundAndBorderArgs);
  var keyboardFocusedBorderColor = designContext.get('transaction-checkbox/keyboard-focused-border-color', BackgroundAndBorderArgs);
  var borderRadius = designContext.get('transaction-checkbox/corner-radius', BackgroundAndBorderArgs).pixelValue;
  return {
    iconWrapper: {
      position: 'absolute',
      top: -1,
      left: -1
    },
    overlayStyle: {
      borderRadius: isLollipop(designVersion) ? 5 + 3 : designContext.get('transaction-checkbox/keyboard-focus-corner-radius').pixelValue,
      borderColor: focused && !disabled ? keyboardFocusedBorderColor.toString() : designContext.get('colors/borders/transparent').toString(),
      borderWidth: 2,
      borderStyle: 'solid',
      height: 30,
      boxSizing: 'border-box',
      left: -6,
      top: -6,
      right: 0,
      bottom: 0,
      position: 'absolute',
      transition: 'border-color .2s ease',
      width: 30,
      zIndex: -1
    },
    rootStyle: {
      width: 20,
      height: 20,
      top: 4,
      borderRadius: isLollipop(designVersion) ? 5 : borderRadius,
      backgroundColor: backgroundColor.toString(),
      boxSizing: 'border-box',
      borderColor: borderColor.toString(),
      borderWidth: 1,
      borderStyle: 'solid'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map